<script setup>
/**
 * Branded native `<input type="file">`. Wraps the canonical Tailwind `file:`
 * variant recipe so file pickers look native to the rest of the app (orange
 * chip button + muted caption + uppercase mono label).
 *
 * Forwards the native `change` event so callers wire `@change="handler"`
 * exactly like they would on a raw input. The `id` is required so a sibling
 * `<InputLabel for>` and `<InputError id>` can associate properly.
 */
defineProps({
    id: {
        type: String,
        required: true,
    },
    accept: {
        type: String,
        default: null,
    },
})

defineEmits(['change'])
</script>

<template>
    <input
        class="text-on-surface-variant file:bg-primary-container file:text-on-primary-container hover:file:bg-primary-container/90 block w-full text-sm file:mr-4 file:cursor-pointer file:rounded file:border-0 file:px-4 file:py-2 file:text-sm file:font-bold file:tracking-widest file:uppercase"
        :id="id"
        type="file"
        :accept="accept"
        @change="$emit('change', $event)"
    />
</template>
